module.exports = __webpack_public_path__ + "pa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pa.svg
// module id = 1002
// module chunks = 0